import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { PalletAccountsClient } from "@/features/palletAccounts/PalletAccountsClient";

// Transport → Palletrekening (docs/scantafel.md §5): the balances per relation, and the euros bought of a customer.
// Reading as the pallet check — tms_orders or tms_orders_write — or with pallet_accounts_write, which books.
export const Route = createFileRoute("/_shell/pallet-accounts/")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_orders") && !hasModule(context.session, "tms_orders_write") && !hasModule(context.session, "pallet_accounts_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: PalletAccountsScreen,
});

function PalletAccountsScreen() {
  const { session } = Route.useRouteContext();
  return (
    <div className="wl-page wl-page--list">
      <PalletAccountsClient userId={session.userId} canWrite={hasModule(session, "pallet_accounts_write")} />
    </div>
  );
}
